export const initialState = {
    copyText: null,
    onCopySuccess: () => {},
    onCopyError: () => {},
    executeCopy: false, //en caso de que el texto en redux siga siendo
    // el mismo pero aun así se quiere volver a copiar. Pasar executeCopy a true vuelve a ejecutar el copiado.
  }